/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { createRoot } from "react-dom/client";
import { App } from "./App";

// Capture install prompt as early as possible, before React mounts
export let deferredInstallPrompt: Event | null = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredInstallPrompt = e;
  window.dispatchEvent(new CustomEvent("pwa-install-ready"));
});

function start() {
  const root = createRoot(document.getElementById("root")!);
  root.render(<App />);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js');
}

// Inject PWA meta tags (kept out of index.html so Bun doesn't try to bundle them)
const head = document.head;
const addLink = (rel: string, attrs: Record<string, string>) => {
  const el = document.createElement('link');
  el.rel = rel;
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  head.appendChild(el);
};
addLink('manifest', { href: '/manifest.json' });
addLink('icon', { type: 'image/png', href: '/favicon-96x96.png', sizes: '96x96' });
addLink('icon', { type: 'image/svg+xml', href: '/favicon.svg' });
addLink('shortcut icon', { href: '/favicon.ico' });
addLink('apple-touch-icon', { sizes: '180x180', href: '/apple-touch-icon.png' });
const themeMeta = document.createElement('meta');
themeMeta.name = 'theme-color';
themeMeta.content = '#ffffff';
head.appendChild(themeMeta);
